module.exports = __webpack_public_path__ + "static/media/search.348bcb20.svg";